import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PolicyReviewAtRenewalDeleteRequestParams, PolicyReviewAtRenewalDeleteResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { reviewAtRenewalQueryKeys } from './keys';

export const useDeleteReviewAtRenewal = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation<PolicyReviewAtRenewalDeleteResponse, Error, PolicyReviewAtRenewalDeleteRequestParams>({
    mutationFn: ({ policyId }: PolicyReviewAtRenewalDeleteRequestParams) =>
      client.delete(`policy/${policyId}/review-at-renewal`).json<PolicyReviewAtRenewalDeleteResponse>(),
    onSuccess: (_, { policyId }) => {
      queryClient.invalidateQueries({
        queryKey: reviewAtRenewalQueryKeys.get(policyId),
      });
      queryClient.invalidateQueries({
        queryKey: ['policy', { policyId }],
      });
    },
  });

  return { ...result, deleteReviewAtRenewal: result.mutateAsync };
};
